import React from "react";
import ControlPanel from "./ControlPanel";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlPhotoVoltaic } from "./types";

interface IControlPhotoVoltaicProps {
  control: IControlPhotoVoltaic;
}

const ControlPhotoVoltaic = (props: IControlPhotoVoltaicProps) => {
  const { control } = props;
  const batteryLevelPercent = useControlAttribute(
    control,
    "bat_energy_percent",
  );
  const mode = control.is_enabled ? "on" : "disabled";
  const iconColor = useModeColor(mode);

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={batteryLevelPercent + "%"}
    >
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name="solar-power-variant-outline"
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlPhotoVoltaic;
